export const PERSONAL_ACCOUNT = 'personalAccount';

export const PERSONAL_ACCOUNT_ACTIONS_NAME = {
  fetchCountries: `${PERSONAL_ACCOUNT}/fetchCountries`,
  fetchMoreCountries: `${PERSONAL_ACCOUNT}/fetchMoreCountries`,
  setIsLoading: `${PERSONAL_ACCOUNT}/setIsLoading`,
} as const;

export const PERSONAL_ACCOUNT_MUTATIONS_NAME = {
  setListOfCountry: `setListOfCountry`,
  setMoreListOfCountry: `setMoreListOfCountry`,
  setIsLoading: `${PERSONAL_ACCOUNT}/setIsLoading`,
} as const;

export const PERSONAL_ACCOUNT_GETTERS_NAME = {
  getListOfCountry: `${PERSONAL_ACCOUNT}/getListOfCountry`,
  getIsLoading: `${PERSONAL_ACCOUNT}/getIsLoading`,
  getIsLoadingMore: `${PERSONAL_ACCOUNT}/getIsLoadingMore`,
} as const;
